<template>
  <v-layout class="grey lighten-4" column>
    <v-flex xs12>
      <div class="mb-3">
        <v-row>
          <v-col>
            <div class="title">
              Orden de compra: {{ order.uuid }}
            </div>
          </v-col>
          <v-col>
            <v-btn
              color="primary"
              depressed
              target="_blank"
              :href="downloadLink"
            >
              Descargar la orden
            </v-btn>
          </v-col>
        </v-row>
      </div>

      <v-card class="mb-3">
        <div class="px-3">
          <v-row>
            <v-col>
              <div>
                Restaurant:
              </div>
              <div>
                {{ order.restaurant.name }}
              </div>
            </v-col>
            <v-col>
              <div>
                Area:
              </div>
              <div>
                {{ order.area.name }}
              </div>
            </v-col>
            <v-col>
              <div>
                Se realizó el:
              </div>
              <div>
                {{ order.createdAt }}
              </div>
            </v-col>
          </v-row>
        </div>
      </v-card>

      <div class="mb-3">
        <v-row>
          <v-col>
            <div class="title">
              Productos
            </div>
          </v-col>
          <v-col>
            <div>
              Total de Artículos: {{ order.totalProducts }}
            </div>
          </v-col>
        </v-row>
      </div>

      <v-card class="mb-3">
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th>Número</th>
                <th>Nombre</th>
                <th>Unidad</th>
                <th>Cantidad solicitada</th>
                <th>Cantidad confirmada</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in order.products"
                :key="item.name"
              >
                <td>{{ item.number }}</td>
                <td>{{ item.name }}</td>
                <td>{{ item.unit.name }}</td>
                <td>{{ item.quantityRequested }}</td>
                <td></td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card>

      <v-card class="mb-3">
        <div class="px-3">
          <v-row>
            <v-col>
              <div>
                Notas:
              </div>
              <div>
                {{ order.notes }}
              </div>
            </v-col>
          </v-row>
        </div>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  data: function () {
    return {
      order: {}
    }
  },
  computed: {
    orderId () {
      return this.$route.params.id
    },
    downloadLink () {
      return `${process.env.VUE_APP_API_URL}/v1/orders/${this.orderId}/download?sentBy=${this.sentBy}`
    },
    sentBy () {
      return this.$route.query.sentBy
    }
  },
  async mounted () {
    const order = await this.$api.get(`/v1/orders/${this.orderId}/download`, { view: true })
    this.order = order
  }
}
</script>
